let takeout = {
  path: "takeout",
  name: "takeout",
  redirect: "/takeout/list",
  component: () => import("@/views/takeout/index.vue"),
  meta: {
    name: "外卖",
  },
  children: [
    {
      path: "list",
      name: "goodslist",
      component: () => import("@/views/takeout/list.vue"),
      meta: {
        name: "商品管理",
      },
    },
    {
      path: "goods",
      name: "goodsDetail",
      component: () => import("@/views/takeout/goods.vue"),
      meta: {
        name: "商品",
      },
    },
  ],
};

export default takeout;
